import React from "react";
import PropTypes from "prop-types";
import Button from "../../utils/Button";

import AutocompleteDropdown from "../../utils/AutoCompleteDropdown";
import { ONBOARDING_STATUS } from "../../utils/constants";

const OnboardingStep1 = (props) => {
  const {
    step,

    verificationLoader,
    handleRowUpdate,
    countryOptions,
    formData,
    setFormData,
  } = props;

  const inputStyle = {
    width: "100%",
    padding: "8px",
    marginBottom: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
    color: "#808080",
    backgroundColor: "#F6F6F6",
  };

  // Handle Input Change
  const handleChange = (name, value) => {
    // const { name, value } = e.target;

    // Update the countryCode dynamically when the country changes
    if (name === "country") {
      const selectedCountry = countryOptions.find(
        (country) => country.code === value
      );
      setFormData({
        ...formData,
        country: selectedCountry.code,
        countryCode: selectedCountry.phoneCode,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const headerStyle = {
    fontSize: "16px",
    fontWeight: "600",
    color: "#3C3C3C",
    margin: "2rem 0rem 1rem 0rem",
  };

  const handleUpdate = () => {
    handleRowUpdate({
      updateData: {
        firstname: formData?.firstName,
        lastname: formData?.lastName,
        phoneNumber: `${formData?.countryCode}${formData?.phoneNumber}`,
        nationality: formData?.nationality,
        onboardingStatus: {
          status: ONBOARDING_STATUS.IN_ONBOARDING_2,
        },
      },
    });
  };

  const isFormIncomplete = () => {
    return Object.values(formData).some((value) => value.length === 0);
  };

  return (
    <div style={{ width: "100%", color: "#3C3C3C" }}>
      <div>
        <div style={headerStyle}>Basic Information</div>
        <form style={{ fontSize: "14px" }}>
          {/* First Name */}
          <label style={{ display: "block", marginBottom: "5px" }}>
            First Name
          </label>
          <input
            type="text"
            maxLength="250"
            name="firstName"
            value={formData?.firstName}
            onChange={(e) => handleChange("firstName", e.target.value)}
            placeholder="First Name"
            style={inputStyle}
          />

          {/* Last Name */}
          <label style={{ display: "block", margin: "10px 0 5px" }}>
            Last Name
          </label>
          <input
            type="text"
            name="lastName"
            maxLength="250"
            value={formData?.lastName}
            onChange={(e) => handleChange("lastName", e.target.value)}
            placeholder="Last Name"
            style={inputStyle}
          />

          <label style={{ display: "block", margin: "10px 0 5px" }}>
            Phone Number
          </label>
          <div style={{ ...inputStyle, display: "flex" }}>
            <AutocompleteDropdown
              options={countryOptions?.map((nation) => ({
                label: nation.code,
                value: nation.code,
              }))}
              placeholder={formData?.country}
              selectedOption={formData?.country}
              onSelect={(value) => handleChange("country", value)}
              optionWindowHeight="7rem"
              style={{
                backgroundColor: "#F6F6F6",
                width: "5rem",
                outline: "none",
              }}
              optionWindowStyle={{ right: "1rem" }}
            />
            <input
              type="text"
              name="countryCode"
              value={formData?.countryCode}
              readOnly
              style={{
                width: "50px",
                textAlign: "center",
                outline: "none",
                backgroundColor: "transparent",
              }}
            />
            <input
              type="text"
              name="phoneNumber"
              value={formData?.phoneNumber}
              maxLength="15"
              onChange={(e) => {
                const value = e.target.value;
                // Allow only numeric values and disallow negatives
                if (/^\d*$/.test(value)) {
                  handleChange("phoneNumber", value); // Update formData
                }
              }}
              placeholder="XXX-XXX-XXXX"
              style={{
                flex: "2",
                outline: "none",
                backgroundColor: "transparent",
              }}
            />
          </div>

          {/* Nationality */}
          <label style={{ display: "block", margin: "10px 0 5px" }}>
            Nationality
          </label>
          <AutocompleteDropdown
            options={countryOptions?.map((nation) => ({
              label: nation.nationality,
              value: nation.nationality,
            }))}
            placeholder={formData?.nationality}
            onSelect={(value) => handleChange("nationality", value)}
            optionWindowHeight="7rem"
            name="nationality"
            selectedOption={formData?.nationality}
          />
          {/* <select
            name="nationality"
            value={formData?.nationality}
            onChange={(e)=>handleChange("nationality", e.target.value)}
            style={inputStyle}
          >
            {countryOptions?.map((nation, index) => (
              <option
                key={index}
                value={nation?.nationality}
                style={{ fontSize: "10px" }}
              >
                {nation?.nationality}
              </option>
            ))}
          </select> */}
        </form>
        <br />
        <Button
          type={"button"}
          text={"Continue"}
          size={"md"}
          onClick={() => handleUpdate(step)}
          loading={verificationLoader}
          disabled={isFormIncomplete()}
        />
      </div>
    </div>
  );
};

OnboardingStep1.propTypes = {
  step: PropTypes.number.isRequired,
  next: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
};

export default OnboardingStep1;
